var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.352,
    height: 19,
    viewBox: "0 0 20.352 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "list_active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#21a2ee;}.b{fill:none;stroke:#54a0e8;stroke-width:3px;}.c{stroke:#b7b7b7;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1401 -193)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5,
    height: 5,
    rx: 0.3,
    transform: "translate(1401 193)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5,
    height: 5,
    rx: 0.3,
    transform: "translate(1401 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5,
    height: 5,
    rx: 0.3,
    transform: "translate(1401 207)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 13.781,
    transform: "translate(1407.57 195.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 13.781,
    transform: "translate(1407.57 202.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 13.781,
    transform: "translate(1407.57 209.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15.93,0",
    transform: "translate(1397.57 202.965)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListActive);
export default __webpack_public_path__ + "static/media/list_active.0497793f9795a5a08484891c3438e659.svg";
export { ForwardRef as ReactComponent };